import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../-LazyRoutePage"

const UserSettingsPage = lazy(
  () => import("../../components/Settings/UserSettingsPage"),
)

export const Route = createFileRoute("/_layout/user-settings")({
  component: UserSettingsRoute,
})

function UserSettingsRoute() {
  return (
    <LazyRoutePage>
      <UserSettingsPage />
    </LazyRoutePage>
  )
}
